var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { styled } from "@mui/material/styles";
import { faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Box, Typography } from "@mui/material";
import { Icon, theme } from "@sequentech/ui-essentials";
import { FileInput } from "react-admin";
import { JsonField } from "react-admin-json-view";
import { useTranslation } from "react-i18next";
var DragFileElement = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 1rem;\n    padding: 1rem;\n    border-radius: 1rem;\n    border: 2px dashed ", ";\n    background-color: ", ";\n    & .RaFileInput-dropZone {\n        margin-top: 1rem;\n        height: 80px;\n        border-radius: 1rem;\n    }\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 1rem;\n    padding: 1rem;\n    border-radius: 1rem;\n    border: 2px dashed ", ";\n    background-color: ", ";\n    & .RaFileInput-dropZone {\n        margin-top: 1rem;\n        height: 80px;\n        border-radius: 1rem;\n    }\n"])), theme.palette.grey[500], theme.palette.lightBackground);
export var FileJsonInput = function (props) {
    var parsedValue = props.parsedValue, fileSource = props.fileSource, jsonSource = props.jsonSource;
    var t = useTranslation().t;
    var getJsonText = function (value, parsedValue) {
        var url = URL.createObjectURL(value); //Create Object URL
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, false); //Synchronous XMLHttpRequest on Object URL
        xhr.overrideMimeType("text/plain; charset=x-user-defined"); //Override MIME Type to prevent UTF-8 related errors
        xhr.send();
        URL.revokeObjectURL(url);
        var returnText = "";
        for (var i = 0; i < xhr.responseText.length; i++) {
            returnText += String.fromCharCode(xhr.responseText.charCodeAt(i) & 0xff);
        } //remove higher byte
        return __assign(__assign({}, parsedValue.configuration), (JSON.parse(returnText) || {}));
    };
    return (_jsxs(Box, { sx: { padding: "1rem 0" }, children: [_jsxs(DragFileElement, { children: [_jsx(Icon, { variant: "info", icon: faCloudArrowUp, fontSize: "50px" }), _jsx(FileInput, { label: false, source: fileSource, accept: {
                            "application/json": [".json"],
                        }, parse: function (value) {
                            return getJsonText(value, parsedValue);
                        }, sx: { backgroundColor: "transparent" }, children: _jsx(Box, { sx: {
                                display: "none",
                            } }) })] }), _jsx(Typography, { variant: "body1", component: "span", sx: { fontWeight: "bold", margin: 0, display: { xs: "none", sm: "block" } }, children: t("common.label.json") }), _jsx(JsonField, { source: jsonSource, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } })] }));
};
export default FileJsonInput;
var templateObject_1;
